/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ContactTermsReceivables } from '@gh/builder-shared-data';
import {
  ContextRoute,
  getContextRouteInitData,
  getContextRouteStaticData,
} from '@gh/common-internal-shared';
import { EnumDictionary } from '@gh/common-shared';
import { assign } from 'lodash';
import { ContactDetailsFormState } from '../contact-details-tab-container/contact-details-form.service';
import { ContactDetailsSharedTermsPayerFormState } from './contact-details-shared-terms-payer-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-details-shared-terms-payer-tab',
  templateUrl: 'contact-details-shared-terms-payer-tab.component.html',
})
export class ContactDetailsSharedTermsPayerTabComponent implements OnInit {
  form: ContactDetailsSharedTermsPayerFormState;
  termsReceivables: EnumDictionary<ContactTermsReceivables>;

  constructor(private route: ContextRoute,
              rootForm: ContactDetailsFormState) {
    this.form = <ContactDetailsSharedTermsPayerFormState>rootForm
      .getChildForm(getContextRouteStaticData(this.route)['tab'])
      .getChildForm('terms');
  }

  get balancePlaceholder(): string {
    switch (this.form.paymentIsDue) {
      case ContactTermsReceivables.OnMonthDay:
      case ContactTermsReceivables.MonthDayAfterEOM:
        return 'lbl_terms_due_day';
      default:
        return 'lbl_terms_balance_due';
    }
  }

  ngOnInit(): void {
    assign(this, getContextRouteInitData(this.route));
  }

  onPaymentIsDueChange(): void {
    this.form.update();
  }
}
